<small class="debug">{{me}}</small>
<app-button-bar [items]="highlightedRows" [setButtons]="buttons" (buttonEmit)="$event.name === 'add' ? onAdd($event) : onRemove($event)"></app-button-bar>
<table mat-table multiTemplateDataRows [dataSource]="dataSource" class="mat-elevation-z8 matTableMaxSpace">
  <ng-container matColumnDef="from">
    <th mat-header-cell [resizeColumn]="true" *matHeaderCellDef>{{'general.from' | transloco}} </th>
    <td mat-cell class="textAlignLeft" *matCellDef="let element; let index = index">
      {{element.$.from | PipeTruncate:['12']}}
    </td>
  </ng-container>
  <ng-container matColumnDef="command">
    <th mat-header-cell [resizeColumn]="true" *matHeaderCellDef>{{'general.command' | transloco}}</th>
    <td mat-cell *matCellDef="let element">
      {{commandName(element.$.command)}}
    </td>
  </ng-container>
  <ng-container matColumnDef="broadcast">
    <th mat-header-cell [resizeColumn]="true" *matHeaderCellDef>{{'general.broadcast' | transloco}}</th>
    <td mat-cell *matCellDef="let element; let index = dataIndex">
      @if (element.$.command === 'save') {
        <mat-checkbox [checked]="element?.Params[0]?.Param[0]?.$?.broadcast === '1'" (change)="broadcastChanged(index, element)"></mat-checkbox>
      }
    </td>
  </ng-container>
  <ng-container matColumnDef="zone">
    <th mat-header-cell [resizeColumn]="true" *matHeaderCellDef>Zone</th>
    <td mat-cell *matCellDef="let element">
      {{element.$.zone || '0'}}
    </td>
  </ng-container>
  <ng-container matColumnDef="select">
    <th mat-header-cell [resizeColumn]="true" *matHeaderCellDef>{{'general.options' | transloco}}</th>
    <td mat-cell *matCellDef="let element; let index = index">
      {{selectDisplay(element)}}
    </td>
  </ng-container>
  <ng-container matColumnDef="field">
    <th mat-header-cell [resizeColumn]="true" *matHeaderCellDef>{{'general.field' | transloco}}</th>
    <td mat-cell class="textAlignLeft" *matCellDef="let element; let index = index">
      {{element?.Params[0]?.Field[0]?.$?.name}}
      <!-- <editable (update)="fieldEdited(index, element, $event)" *ngIf="element.$.command === 'addParamFieldLine'">
      <ng-template viewMode>
        {{element?.Params[0]?.Field[0]?.$?.name}}
      </ng-template>
      <ng-template editMode>
        <input inputrestriction="basic1"  (keyup)="onFilter($event)" matTooltip="enter to finish" style="width: 100px !important;" #editInput value="{{element?.Params[0]?.Field[0]?.$?.name}}" focusable editableOnEnter>
      </ng-template>
    </editable> -->
  </td>
</ng-container>

<ng-container matColumnDef="editIcon">
  <th mat-header-cell *matHeaderCellDef></th>
  <td mat-cell *matCellDef="let element; let index = dataIndex">
    @if (expandedElement != element) {
      <span class="drgIcon" (click)="expandEditor(element, index)">
        <mat-icon matTooltip="{{'general.edit' | transloco}}"
          [ngStyle]="{'color': 'var(--background-green)'}">
          edit
        </mat-icon>
      </span>
    }
  </td>
</ng-container>

<ng-container matColumnDef="expandedPanel">
  <td mat-cell *matCellDef="let element; let index = dataIndex;" [attr.colspan]="displayedColumnsWithEdit.length" style="padding-right: 0;">
    <div class="edit-panel-wrapper"
      [@detailExpand]="element === expandedElement ? 'expanded' : 'collapsed'">
      <div class="edit-panel">
        @for (col of displayedColumns; track col) {
          @if (col === 'from') {
            <div>
              <mat-form-field style="width: 80%;">
                <mat-label>from</mat-label>
                <input matInput inputrestriction="basic1" type="text"
                  value="{{element.$.from}}"
                  (keyup)="onFilter($event)"
                  (change)="inputEdited(col, index, $event.target['value'])"
                  (keydown.enter)="inputEdited(col, index, $event.target['value'], true)">
                  <!--                                       [matAutocomplete]="auto">-->
                  <!--                                <mat-autocomplete #auto="matAutocomplete" (optionSelected)="inputEdited(col, index, $event.option.value)">-->
                  <!--                                    <mat-option *ngFor="let option of eventsAllFiltered" [value]="option">-->
                  <!--                                        {{option}}-->
                <!--                                    </mat-option>-->
              <!--                                </mat-autocomplete>-->
            </mat-form-field>
          </div>
        }
        @if (col === 'select' && element.$.command === 'selectPage') {
          <div>
            <mat-form-field style="width: 80%;">
              <mat-label>{{'general.selection' | transloco}}</mat-label>
              <mat-select [(value)]="element.Params[0].Page[0].$.name" (selectionChange)="pageValueChanged(index, $event, element)">
                @for (option of dropdownSelect; track option) {
                  <mat-option [value]="option.$.page">
                    {{option.$.page}}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        }
        @if (col === 'select' && element.$.command === 'openPopup') {
          <div>
            <mat-form-field style="width: 80%;">
              <mat-label>{{'general.selection' | transloco}}</mat-label>
              <mat-select [(value)]="element.Params[0].Page[0].$.name" (selectionChange)="pageValueChanged(index, $event, element)">
                @for (option of sceneOptions; track option.value) {
                  <mat-option [value]="option.value">
                    {{option.label}}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        }
        @if (col === 'command') {
          <div>
            <mat-form-field style="width: 80%;">
              <mat-label>{{'general.selection' | transloco}}</mat-label>
              <mat-select (selectionChange)="dropdownOnSelectionChanged($event, element)" [(value)]="element.$.command" placeholder="{{'general.selection' | transloco}}">
                @for (option of commandOptions; track option) {
                  <mat-option [value]="option.value">{{option.name}}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        }
        @if (col === 'zone' && element.$.command !== 'arm') {
          <div>
            <mat-form-field style="width: 80%;">
              <mat-label>Zone</mat-label>
              <mat-select [(value)]="element.$.zone" (selectionChange)="zoneValueChanged(index, $event, element)">
                <mat-option value="0">0</mat-option>
                <mat-option value="1">1</mat-option>
                <mat-option value="2">2</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        }
        @if (col === 'field' && element.$.command === 'addParamFieldLine') {
          <div>
            <mat-form-field style="width: 80%;">
              <mat-label>from</mat-label>
              <input matInput inputrestriction="basic1" type="text"
                value="{{element?.Params[0]?.Field[0]?.$?.name}}"
                (change)="inputEdited(col, index, $event.target['value'])"
                (keydown.enter)="inputEdited(col, index, $event.target['value'], true)">
              </mat-form-field>
            </div>
          }
        }
      </div>
      <button mat-icon-button class="icon-edit-done" (mousedown)="collapseEditor();">
        <mat-icon [ngStyle]="{'color': 'var(--background-green)'}" style="font-size: 18px !important;" matTooltip="{{'general.save' | transloco}}"> check</mat-icon>
      </button>
      <button mat-icon-button class="icon-add-done" (mousedown)="openEventsExplorerDialog($event)">
        <mat-icon style="font-size: 18px !important;" matTooltip="{{'general.add' | transloco}}"> notification_add</mat-icon>
      </button>
    </div>
  </td>
</ng-container>

<tr mat-header-row *matHeaderRowDef="displayedColumnsWithEdit"></tr>
<tr mat-row (click)="onSelectedRow(row)" class="table-row" tabindex="1" *matRowDef="let row; columns: displayedColumnsWithEdit" [style.background]="highlightedRows.indexOf(row) > -1 ? 'var(--background-default2)' : ''"></tr>
<tr mat-row *matRowDef="let row; columns: ['expandedPanel']" class="edit-panel-row"></tr>
</table>



